import React from 'react';

import noResults from '../_assets/new/no_results.png';

function NoResults(props) {
  return (
    <div className="no-results text-center">
      <img src={noResults} />
      <div className="title">No encontramos resultados</div>
      <div className="description">
        {props.description
          ? props.description
          : 'Intenta realizar otra búsqueda o inténtalo más tarde.'}
      </div>
    </div>
  );
}

export default NoResults;
